<template>
	<div class="send-command" :class="[source == 'list' ? 'batch' : 'one']">
		<el-button type="primary" v-if="source == 'list'" @click.native="initCommandList">批量指令任务生成</el-button>
		<el-button class="one-send" type="primary" @click="initCommandList" v-else>指令下发</el-button>
		<gc-dialog
			:show.sync="showDialog"
			:title="btnText"
			:width="source === 'list' ? '1080px' : '800px'"
			@close="handleDialogClose"
		>
			<div class="item-box">
				<span class="item-box-title" v-if="tenantType == 1 && source == 'list'">指令表单</span>
				<div class="item-box-content">
					<div class="meter-type-search" v-if="source == 'list'">
						<gc-custom-search
							keyWord="设备类型"
							width="100%"
							type="select"
							filterable
							:search.sync="batchDeviceTypeId"
							:searchOption="options.deviceTypeId"
						></gc-custom-search>
					</div>
					<div
						v-loading="loadingContent"
						element-loading-text="拼命加载中"
						element-loading-spinner="el-icon-loading"
						class="command-box"
					>
						<gc-empty v-if="commandParams.length == 0"></gc-empty>
						<div class="command-wrapper" v-else>
							<div class="command-sort row-block">
								<div class="title-pale">指令类型</div>
								<div
									class="menu-item"
									v-for="item in commandSortList"
									:key="item.cmdModelType"
									:class="{ active: item.cmdModelType == cmdModelType }"
									@click="handleCommandSortClick(item.cmdModelType)"
								>
									<span class="iconfont" :class="item.icon"></span>
									{{ item.cmdModelTypeName }}
								</div>
							</div>
							<div class="command-list row-block">
								<div class="title-pale">指令</div>
								<div
									class="menu-item"
									v-for="item in commandSortChildren"
									:key="item.cmdModelId"
									:class="{ active: item.cmdModelId == cmdModelId }"
									:title="item.name"
									@click="handleCommandClick(item)"
								>
									{{ item.name }}
								</div>
							</div>
							<div class="command-content">
								<gc-empty v-if="!cmdModelId" pageType="directiveSend"></gc-empty>
								<command-form ref="commandFormParent" v-else :command-form="commandForm"></command-form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="item-box" v-if="tenantType === '1' && source === 'list'">
				<span class="item-box-title">其他参数</span>
				<div class="item-box-content other-params">
					<gc-custom-search
						key-word="客户类型"
						type="select"
						:search-option="options.userType"
						:search.sync="userType"
						:search-option-key="{ label: 'name', value: 'defaultValue' }"
						:selectClearable="true"
					></gc-custom-search>
					<gc-custom-search
						key-word="所属区域"
						type="tree-select"
						width="380px"
						:search.sync="waterRegionCode"
						:searchOption="treeOptions"
						:propsObj="{
							label: 'name',
							children: 'children',
							id: 'code',
							disabled: data => {
								return data.unSelectFlag && data.unSelectFlag === 1
							},
						}"
						:treeSelectClearable="true"
					></gc-custom-search>
				</div>
			</div>
			<div class="send-cmd-form" v-if="source === 'list'">
				<el-form ref="cmdForm" :model="form">
					<el-form-item label="筛选方式" prop="filterMethod" label-position="left" style="margin-bottom: 8px">
						<el-radio-group v-model="form.filterMethod">
							<el-radio label="0">条件筛选</el-radio>
							<el-radio label="1">文件导入</el-radio>
						</el-radio-group>
						<a v-show="form.filterMethod === '1'" class="download" :href="downloadPath">下载模板</a>
					</el-form-item>
					<div class="conditional-filter-list" v-if="form.filterMethod === '0'">
						<div class="conditional-filter-item" v-if="isEtbcTenant">
							<gc-custom-search
								class="search"
								key-word="所属组织"
								width="100%"
								type="cascader"
								:search-option="orgCodeOptions"
								:search-option-key="orgTreeProps"
								:search.sync="form.orgCode"
							></gc-custom-search>
						</div>
						<div class="conditional-filter-item" v-if="tenantType === '0'">
							<gc-custom-search
								class="search"
								key-word="使用类型"
								width="100%"
								type="select"
								:search-option="searchOptions['useType']"
								:search.sync="form['useType']"
								:search-option-key="{ label: 'name', value: 'defaultValue' }"
								needAllForSearch
							></gc-custom-search>
						</div>
						<div class="conditional-filter-item" v-if="tenantType === '0'">
							<gc-custom-search
								class="search"
								key-word="安装位置"
								width="100%"
								type="select"
								:search-option="searchOptions['installLocation']"
								:search-option-key="{ label: 'name', value: 'defaultValue' }"
								:search.sync="form['installLocationList']"
								needAllForSearch
								multiple
							></gc-custom-search>
						</div>
						<div class="conditional-filter-item" v-if="tenantType === '1'">
							<gc-custom-search
								class="search"
								key-word="安装位置"
								width="100%"
								type="cascader"
								:search-option="installLocationOptions"
								:search.sync="form['installLocation']"
								needAllForSearch
							></gc-custom-search>
						</div>
						<div class="conditional-filter-item">
							<gc-custom-search
								class="search"
								key-word="安装日期"
								width="100%"
								type="date"
								datePickerType="daterange"
								:search.sync="form['installDate']"
								valueFormat="yyyy-MM-dd"
							></gc-custom-search>
						</div>
					</div>
					<el-form-item v-if="form.filterMethod === '1'" style="margin-bottom: 0">
						<el-upload
							class="btn"
							ref="upload"
							action
							drag
							:auto-upload="false"
							:show-file-list="false"
							:on-change="handleFileChange"
						>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">
								将文件拖到此处，或
								<em>点击上传</em>
								<el-tooltip :visible-arrow="false" effect="dark" placement="top">
									<i style="margin-left: 4px; color: #999" class="el-icon-question"></i>
									<div slot="content" style="line-height: 16px">
										<p>可先从【设备管理-台账管理】筛选并导出设备清单;</p>
										<p>可自定义下载模板并完善设备清单;</p>
										<p>每次批量任务仅支持对同一设备类型批量下发相同参数。</p>
									</div>
								</el-tooltip>
							</div>
						</el-upload>
						<div v-show="file.name" class="file" :title="file.name">
							<div class="file-name">
								<p class="text">【{{ file.name }}】</p>
								<p>
									已导入
									<span class="length">{{ file.data.length }}</span>
									条数据
								</p>
							</div>
							<i class="iconfont el-icon-circle-close" @click="handleDeleteFile"></i>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="footer">
				<el-button @click="handleDialogClose">取 消</el-button>
				<el-button
					type="primary"
					:disabled="!cmdModelId || commandParams.length == 0"
					@click.native="confirmToSend"
					:loading="loadingBtn"
					:class="[loadingBtn ? 'loading-width' : '']"
				>
					提 交
				</el-button>
			</div>
		</gc-dialog>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { isBlank } from '@/utils/validate'
import {
	apiGetCommandList,
	apiBatchSendCommand,
	apiOneSendCommand,
	apiGetCmdModelBatchSendNum,
} from '@/apis/batchDirectiveManage.api'
import { apiGetOrgIsolationTree } from '@/apis/organizeRole.api'
import Bus from '@/utils/eventBus'
import { isEtbcTenant } from '@/utils'
import CommandForm from './CommandForm.vue'
const XLSX = require('xlsx')

export default {
	name: 'sendCommand',
	components: {
		CommandForm,
	},
	props: {
		btnText: {
			type: String,
			default: '批量指令任务生成',
		},
		source: {
			type: String,
			default: 'list',
		},
		deviceTypeId: [String, Number],
		deviceId: [String, Number],
		options: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			showDialog: false,
			commandParams: [],
			commandSortList: [],
			commandSortChildren: [],
			cmdModelType: '',
			cmdModelId: '',
			batchDeviceTypeId: '',
			userType: '',
			waterRegionCode: '',
			orgCodeOptions: [],
			orgTreeProps: {
				value: 'orgCode',
				label: 'name',
				children: 'children',
				emitPath: false,
			},
			commandForm: {},
			loadingBtn: false,
			loadingContent: false,
			file: { data: [], name: '' },
			searchOptions: {
				userType: [],
				installLocation: [],
			},
			form: {
				filterMethod: '0',
				useType: null,
				installLocationList: [],
				installLocation: null,
				installDate: [],
				orgCode: '',
			},
		}
	},

	created() {
		this.searchOptions.useType = this.$store.getters?.dataList?.useTypeGas || []
		this.getTreeOptions()
	},

	computed: {
		isEtbcTenant() {
			return isEtbcTenant
		},
		userInfo() {
			return this.$store.getters.userInfo
		},
		visibleSwitchTenant() {
			return (
				(this.userInfo?.authRoleIds || []).includes('11') || (this.userInfo?.authRoleIds || []).includes('12')
			)
		},
		tenantType() {
			return this.$store.getters.userInfo.tenantType
		},
		treeOptions() {
			return this.$store.getters.userRegionTree
		},
		downloadPath() {
			return `${process.env.BASE_URL}excel/批量指令任务明细模板.xls`
		},
		installLocationOptions() {
			const options = [
				{ value: '0', label: '户内' },
				{ value: '1', label: '管网' },
			]
			const { installLocation = [] } = this.$store.getters.dataList
			const array = installLocation.map(item => {
				return { value: item.defaultValue, label: item.name }
			})
			options[0].children = array.filter(item => item.value < 10)
			options[1].children = array.filter(item => item.value >= 10 && item.value < 20)
			return options
		},
	},

	watch: {
		batchDeviceTypeId(newVal) {
			if (!isBlank(newVal)) {
				// 数据重置
				this.commandParams = [] //指令参数集
				this.commandSortList = [] //指令类型
				this.commandSortChildren = [] //指令
				this.cmdModelType = '' //当前选中的指令类型
				this.cmdModelId = '' //当前选中的指令
				this.commandForm = {}
				this.$refs?.commandFormParent?.$refs?.commandForm.clearValidate()
				// 请求当前设备的参数集
				this.getCommandList(newVal)
			}
		},

		'form.useType'(newVal) {
			if (newVal) {
				this.searchOptions.installLocation = (this.$store.getters?.dataList?.installLocationGas || []).filter(
					m => m.defaultValue[0] === newVal,
				)
			} else {
				this.searchOptions.installLocation = []
			}
			this.form.installLocationList = null
		},
	},

	methods: {
		...mapActions({
			judgeNeedPickOrg: 'user/judgeNeedPickOrg',
			getTreeOptions: 'user/getTreeOptions',
		}),
		async getOrganizationList() {
			if (!this.isEtbcTenant || this.source !== 'list') return
			try {
				const params = this.visibleSwitchTenant
					? {
							tenantId: this.userInfo.tenantId,
							all: 1,
					  }
					: {}
				const data = await apiGetOrgIsolationTree(params)
				this.orgCodeOptions = [data].filter(Boolean)
			} catch (error) {
				this.orgCodeOptions = []
			}
		},
		initCommandList() {
			if (this.source == 'detail') {
				this.showDialog = true
				this.getCommandList(this.deviceTypeId)
			} else {
				this.judgeNeedPickOrg().then(res => {
					if (res) {
						this.getOrganizationList()
						this.showDialog = true
					}
				})
			}
		},
		handleDialogClose() {
			const originData = this.$options.data.call(this)
			delete originData.searchOptions
			Object.assign(this.$data, originData)
			this.showDialog = false
		},
		handleUpload() {},
		getCommandList(id) {
			this.loadingContent = true
			let params = {
				isBatch: this.source === 'list' ? 1 : undefined,
			}
			if (this.tenantType == 1) {
				// 待补充 参数是否需要确认
				params['deviceTypeId'] = id
			} else {
				params['deviceTypeId'] = id
			}
			apiGetCommandList(params)
				.then((res = []) => {
					const iconArr = ['icon-read_order', 'icon-set_order', 'icon-valve_control_order']
					this.commandParams = res || []
					this.commandSortList = this.commandParams.map(item => {
						return {
							cmdModelType: item.cmdModelType,
							cmdModelTypeName: item.cmdModelTypeName,
							icon: iconArr[item.cmdModelType],
						}
					})
					this.cmdModelType = (this.commandSortList.length > 0 && this.commandSortList[0].cmdModelType) || ''
					this.commandSortChildren =
						(this.commandParams.find(item => item.cmdModelType == this.cmdModelType) || {}).cmdModelList ||
						[]
				})
				.finally(() => {
					this.loadingContent = false
				})
		},
		// 切换指令类型
		handleCommandSortClick(cmdModelType) {
			this.cmdModelType = cmdModelType
			this.cmdModelId = ''
			this.commandSortChildren =
				this.commandParams.find(item => item.cmdModelType == this.cmdModelType).cmdModelList || []
		},
		//切换指令
		handleCommandClick(item) {
			this.cmdModelId = item.cmdModelId
			this.commandForm = item.payload || {}
			if (this.commandForm.identifier === '05-remoteSecurityCheck') {
				this.$set(this.commandForm, 'remoteSecurityCheckRegular', '0')
				this.$set(this.commandForm, 'regularTime', this.dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'))
			}
		},
		// 确定下发
		confirmToSend() {
			this.$refs.commandFormParent.$refs.commandForm.validate(async valid => {
				if (valid) {
					const { remoteSecurityCheckRegular, regularTime, inputData = [], identifier } = this.commandForm
					const cmdInfo = {
						remoteSecurityCheckRegular,
						regularTime,
					}
					// 设置定时上传参数（参数必须是十次，如果页面不展示，则默认为0000）
					if (identifier === '05-uploadDaysAndTimes') {
						inputData.forEach(item => {
							if (item.uiType.display && isBlank(item.dataType.defaultValue)) {
								cmdInfo[item.identifier] = '0000'
							} else {
								cmdInfo[item.identifier] = item.dataType.defaultValue
							}
						})
					} else {
						inputData.forEach(item => {
							cmdInfo[item.identifier] = item.dataType.defaultValue
						})
					}
					const params = {
						cmdInfo,
						waterRegionCode: this.waterRegionCode || undefined,
					}
					if (this.source == 'list') {
						if (this.form.filterMethod === '1' && !this.file?.data?.length) {
							return this.$message.warning('设备明细不能为空，请先下载模板并导入设备明细！')
						}
						this.loadingBtn = true
						if (this.tenantType === '1') {
							params['userType'] = this.userType
							params['waterRegionCode'] = this.waterRegionCode
						}
						params.filterMethod = this.form.filterMethod
						params.orgCode = this.form.orgCode || undefined
						params.deviceTypeId = this.batchDeviceTypeId
						params.cmdModelType = +this.cmdModelType
						params.cmdModelId = this.cmdModelId
						params.cmdModelName = this.commandSortChildren.find(
							item => item.cmdModelId == this.cmdModelId,
						)?.name
						if (this.form.filterMethod === '0') {
							Object.assign(params, {
								...this.form,
								installDateStart: this.form.installDate ? this.form.installDate[0] : undefined,
								installDateEnd: this.form.installDate ? this.form.installDate[1] : undefined,
								installDate: undefined,
							})
							try {
								const count = await apiGetCmdModelBatchSendNum(params)
								if (!count) {
									return this.$message.warning('满足当前筛选条件的设备台数为0，请确保至少有1台设备！')
								}
								await this.$confirm(`将会对${count}台设备下发指令，请仔细核对后下发！`)
							} finally {
								this.loadingBtn = false
							}
						} else {
							params.deviceNos = this.file.data
						}
					} else {
						this.loadingBtn = true
						params.deviceId = this.deviceId
						params.cmdModelId = this.cmdModelId
					}
					const API = this.source == 'list' ? apiBatchSendCommand : apiOneSendCommand
					try {
						await API(params)
						this.$message.success(this.source === 'list' ? '批量任务正在生成' : '指令下发成功')
						if (this.source === 'list') {
							this.$emit('update-list')
						} else {
							this.$store.commit('account/SET_CONFIG_RULE_UPDATE', true)
							Bus.$emit('refresh-command')
						}
						this.showDialog = false
					} finally {
						this.loadingBtn = false
					}
				}
			})
		},

		// 上传文件后获取表格数据
		handleFileChange(file) {
			const { name, size, raw } = file
			if (!/\.(xls|xlsx)$/.test(name.toLowerCase())) {
				this.$message.error('上传文件格式不正确，请上传xls或xlsx格式文档')
				return false
			}
			if (size / 1024 / 1024 > 10) {
				this.$message.error('上传文件大小不得大于10M')
				return false
			}
			const loading = this.$loading({ text: '正在读取，请等待…' })
			const fileReader = new FileReader()
			fileReader.onload = ev => {
				try {
					const data = ev.target.result
					const workbook = XLSX.read(data, {
						type: 'binary',
					})
					const type = XLSX.utils.sheet_to_json(workbook.Sheets['模板类型'])
					console.info('当前模板的类型为:' + type[0]['模板类型'])
					if (type[0]['模板类型'] !== 'BATCH_COMMAND_TASK') {
						this.$message.error('模板错误，请重新下载上传')
						loading.close()
						return
					}
					const v = XLSX.utils.sheet_to_json(workbook.Sheets['版本号'])
					console.info('当前的版本号为:' + v[0]['版本号'])
					if (v[0]['版本号'] != '20250703') {
						this.$message.error('文件校验未通过，请从页面上下载最新的模板！')
						loading.close()
						return
					}
					const sheetNames = workbook.SheetNames
					const ws = XLSX.utils.sheet_to_json(workbook.Sheets[sheetNames[0]], {
						defval: null,
					})
					if (!ws.length) {
						this.$message.error('上传数据不能为空')
						loading.close()
						return
					}
					if (ws.length > 20000) {
						this.$message.error('上传数据不能超过20000条')
						loading.close()
						return
					}
					setTimeout(() => {
						this.file.data = ws.map(item => item['设备通讯编号'])
						this.file.name = name
						loading.close()
					}, 1000)
				} catch {
					loading.close()
					this.$message.error('excel读取发生错误，请重新读取')
				}
			}
			fileReader.readAsBinaryString(raw)
		},
		handleDeleteFile() {
			this.file.name = ''
			this.file.data = []
		},
	},
}
</script>
<style lang="scss" scoped>
.batch {
	@include base-button($width: 150px);
}
.one {
	@include base-button($width: 100px);
	.one-send {
		margin-right: 12px;
	}
}
::v-deep {
	.el-dialog__body {
		padding: 0 0 15px 0 !important;
	}
	.gc-blank-page {
		margin-top: 102px !important;
	}
	.el-upload {
		display: block;
		.el-upload-dragger {
			width: 100%;
			height: 126px;
			// border: 1px solid #f1f1f1;
			.el-icon-upload {
				font-size: 42px;
				margin: 16px 0 0;
			}
			.el-upload__text {
				font-size: 12px;
			}
		}
	}
}
.meter-type-search {
	padding: 0 24px;
	display: flex;
	align-items: center;
	gap: 16px;
}
.download {
	position: absolute;
	right: 0px;
	bottom: 0px;
}
.command-box {
	min-height: 260px;
}
.command-wrapper {
	box-sizing: border-box;
	height: 328px;
	display: flex;
	.row-block {
		height: 100%;
		border-right: 1px solid #f1f1f1;
		overflow-y: auto;
		.title-pale {
			padding: 10px 0 12px 24px;
			font-size: 12px;
			color: #999999;
			line-height: 18px;
		}
		.menu-item {
			padding-left: 24px;
			height: 36px;
			line-height: 36px;
			background: white;
			font-size: 14px;
			font-weight: 400;
			color: #4a4a4a;
			transition: all ease-in-out 0.2s;
			cursor: pointer;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			&.active {
				color: $base-color-primary;
				background: #e9f2fe;
			}
		}
	}
	.command-sort {
		flex: 0 0 160px;
	}
	.command-list {
		flex: 0 0 238px;
	}
	.command-content {
		flex: 1;
		height: 100%;
		padding-top: 8px;
	}
}

.footer {
	@include base-button($height: 32px, $radius: 16px);
	.loading-width {
		width: 100px !important;
	}
}
.item-box {
	border-bottom: 1px solid #f1f1f1;
	.item-box-title {
		width: 100%;
		display: inline-block;
		padding: 0 24px;
		margin: 12px 0;
		color: #ababab;
		position: relative;
		&::after {
			content: '';
			position: absolute;
			left: 90px;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			border-bottom: 1px solid #eef0f3;
		}
	}
	.other-params {
		padding: 0 24px 12px;
		.gc-custom-search {
			width: 100% !important;
			& + .gc-custom-search {
				margin-top: 12px;
			}
		}
	}
}

.send-cmd-form {
	padding: 0 24px;
	margin-top: 12px;
	.conditional-filter-list {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		gap: 6px 1%;
		.conditional-filter-item {
			width: 32%;
		}
	}
}

.file {
	display: flex;
	align-items: center;
	.iconfont {
		margin-left: 8px;
		cursor: pointer;
	}
	.file-name {
		flex: 1;
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #999;

		.text {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		.length {
			font-size: 12px;
			color: #16a65d;
			font-weight: 600;
		}
	}
}
</style>
